// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/course_section.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_schools_v1_resources_course_section_details } from "./course_section_details_pb.js";
import { file_studyo_today_schools_v1_resources_external_source } from "./external_source_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/course_section.proto.
 */
export const file_studyo_today_schools_v1_resources_course_section = /*@__PURE__*/
  fileDesc("CjZzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvY291cnNlX3NlY3Rpb24ucHJvdG8SIXN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcyLrAgoNQ291cnNlU2VjdGlvbhIKCgJpZBgBIAEoCRIRCglzY2hvb2xfaWQYAiABKAkSSgoPZXh0ZXJuYWxfc291cmNlGAMgASgLMjEuc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzLkV4dGVybmFsU291cmNlEjAKDGNyZWF0ZWRfdGltZRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMAoMdXBkYXRlZF90aW1lGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpzeW5jX3Rva2VuGAYgASgDEg0KBXRpdGxlGAcgASgJEg0KBWNvbG9yGAggASgJEkgKB2RldGFpbHMYCSABKAsyNy5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuQ291cnNlU2VjdGlvbkRldGFpbHMSDwoHc2VjdGlvbhgKIAEoCUIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_protobuf_timestamp, file_studyo_today_schools_v1_resources_course_section_details, file_studyo_today_schools_v1_resources_external_source]);

/**
 * Describes the message studyo.today.schools.v1.resources.CourseSection.
 * Use `create(CourseSectionSchema)` to create a new message.
 */
export const CourseSectionSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_course_section, 0);

